import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m0 11H3V3h10z" }, null, -1),
    _createElementVNode("path", { d: "M4.667 4.667h1.409l1.887 4.347h.074l1.887-4.347h1.41v6h-1.106V6.545h-.059l-1.756 4.104h-.826L5.831 6.536h-.06v4.13H4.668z" }, null, -1)
  ]))]))
}
export default { render: render }